module.exports = __webpack_public_path__ + "img/air-conditions.5c508d10.jpg";